import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { SeleccionTablas } from './seleccion-tablas.model';

@Component
export default class SelecciontablasComponent extends Vue {
  @Prop({ required: true })
  public opciones: Array<any>;

  @Prop({
    required: false,
    default: function () {
      return true;
    },
  })
  public sorted: boolean;

  @Prop({
    required: true,
    default: function () {
      return [];
    },
  })
  public keyComp: Array<string>;

  @Prop({
    required: false,
    default: function () {
      return [];
    },
  })
  public inicial: Array<any>;

  @Prop({
    required: false,
    default: function () {
      return false;
    },
  })
  public disabled: boolean;

  @Prop({
    required: false,
    default: function () {
      return undefined;
    },
  })
  public state: boolean;

  public opcionesBase: Array<SeleccionTablas> = [];
  public seleccionadoBase: Array<SeleccionTablas> = [];

  public opcionesFiltrado: Array<SeleccionTablas> = [];
  public seleccionFiltrado: Array<SeleccionTablas> = [];

  public filtroOpciones = '';
  public filtroSelecciones = '';
  public mostrarFiltroOpciones = false;
  public mostrarFiltroSelecciones = false;
  public mostrarDisponiblesExtendidas = false;
  public mostrarSeleccionadasExtendidas = false;

  public mounted(): void {
    this.iniciarComponente();
  }

  @Watch('inicial')
  public inicialWatch(): void {
    this.iniciarComponente();
  }

  @Watch('opciones')
  public opcionesWatch(): void {
    this.iniciarComponente();
  }

  private iniciarComponente(): void {
    this.opcionesBase = [];
    this.seleccionadoBase = [];

    this.opciones.forEach(currItem => {
      this.opcionesBase.push({ item: currItem, text: this.obtenerTextoVisible(currItem) });
    });
    this.inicial.forEach(currItem => {
      this.seleccionadoBase.push({ item: currItem, text: this.obtenerTextoVisible(currItem) });
      this.opcionesBase = this.opcionesBase.filter(el => el.text != currItem.text);
    });
    this.refrescar();
  }

  private refrescar(): void {
    this.filtrarSelecciones();
    this.filtrarOpciones();
    this.cambioSeleccion();
  }

  @Watch('mostrarFiltroOpciones')
  public mostrarFiltroOpcionesWatch(): void {
    if (!this.mostrarFiltroOpciones) {
      this.filtroOpciones = '';
      this.filtrarOpciones();
    }
  }

  @Watch('mostrarFiltroSelecciones')
  public mostrarFiltroSeleccionesWatch(): void {
    if (!this.mostrarFiltroOpciones) {
      this.filtroSelecciones = '';
      this.filtrarSelecciones();
    }
  }

  public pasarTodoASelecciones(): void {
    if (!this.disabled) {
      this.opcionesFiltrado.forEach(item => {
        this.seleccionadoBase.push(item);
      });
      this.opcionesBase = [];
      this.refrescar();
    }
  }

  public pasarTodoAOpciones(): void {
    if (!this.disabled) {
      this.seleccionFiltrado.forEach(item => {
        this.opcionesBase.push(item);
      });
      this.seleccionadoBase = [];
      this.refrescar();
    }
  }

  public pasarASelecciones(item: SeleccionTablas): void {
    if (!this.disabled) {
      this.seleccionadoBase.push(item);
      this.opcionesBase = this.opcionesBase.filter(el => el.text != item.text);
      this.refrescar();
    }
  }

  public pasarAOpciones(item: SeleccionTablas): void {
    if (!this.disabled) {
      this.opcionesBase.push(item);
      this.seleccionadoBase = this.seleccionadoBase.filter(el => el.text != item.text);
      this.refrescar();
    }
  }

  public filtrarOpciones(): void {
    this.opcionesFiltrado = [];
    this.opcionesBase.forEach(item => {
      if (this.filtroOpciones) {
        if (!!item.text && item.text.toLowerCase().includes(this.filtroOpciones.toLowerCase())) {
          this.opcionesFiltrado.push(item);
        }
      } else {
        this.opcionesFiltrado.push(item);
      }
    });
    if (this.sorted) {
      this.opcionesFiltrado.sort(this.sortItems);
    }
  }

  public filtrarSelecciones(): void {
    this.seleccionFiltrado = [];
    this.seleccionadoBase.forEach(item => {
      if (this.filtroSelecciones) {
        if (!!item && item.text.toLowerCase().includes(this.filtroSelecciones.toLowerCase())) {
          this.seleccionFiltrado.push(item);
        }
      } else {
        this.seleccionFiltrado.push(item);
      }
    });
    if (this.sorted) {
      this.seleccionFiltrado.sort(this.sortItems);
    }
  }

  /**
   * Ordena los elementos de las listas.
   *
   * SI LLEGA UNA PROPIEDAD LLAMADA 'orden', ORDENA POR ESE CAMPO, SINO, ORDENA POR EL TEXTO VISIBLE
   */
  private sortItems(a: SeleccionTablas, b: SeleccionTablas): number {
    if (!!a.item?.orden && !!b.item?.orden) {
      if (a.item.orden > b.item.orden) {
        return 1;
      }
      if (a.item.orden < b.item.orden) {
        return -1;
      }
      return 0;
    } else {
      if (!!a.text && !!b.text && a.text.toLowerCase() > b.text.toLowerCase()) {
        return 1;
      }
      if (!!a.text && !!b.text && a.text.toLowerCase() < b.text.toLowerCase()) {
        return -1;
      }
      return 0;
    }
  }

  private obtenerTextoVisible(opcion: any): string {
    let texto = '';

    this.keyComp.forEach(currKey => {
      if (texto.length > 0) {
        texto += ' - ';
      }
      texto += opcion[currKey];
    });

    return texto;
  }

  private cambioSeleccion(): void {
    const seleccion: Array<any> = [];

    if (this.sorted) {
      this.seleccionadoBase.sort(this.sortItems);
    }

    this.seleccionadoBase.forEach(elem => {
      seleccion.push(elem.item);
    });

    this.$emit('change-selection', seleccion);
  }
}
